import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _FULFILLMENT_TYPE_TO_;
export var FULFILLMENT_TYPE_IN_STORE = 'INSTORE';
export var FULFILLMENT_TYPE_SHIPPING = 'SHIPPING';
export var FULFILLMENT_TYPE_DELIVERY = 'DELIVERY';
export var FULFILLMENT_PROVIDER_SHIPPO = 'SHIPPO';
export var FULFILLMENT_PROVIDER_MERCHANT = 'MERCHANT';
export var FULFILLMENT_TYPE_TO_TEXT = (_FULFILLMENT_TYPE_TO_ = {}, _defineProperty(_FULFILLMENT_TYPE_TO_, FULFILLMENT_TYPE_IN_STORE, 'Pickup'), _defineProperty(_FULFILLMENT_TYPE_TO_, FULFILLMENT_TYPE_SHIPPING, 'Shipping'), _defineProperty(_FULFILLMENT_TYPE_TO_, FULFILLMENT_TYPE_DELIVERY, 'Delivery'), _FULFILLMENT_TYPE_TO_);